import React from "react";
import "./Tooltip.css";
import { Box } from "@mui/material";
import { styled } from "@mui/system";

interface TooltipItem {
  text?: string;
  color?: string;
  imageUrl?: string;
}

interface TooltipProps {
  items: TooltipItem[];
  position: { x: number; y: number };
  visible: boolean;
}

const Tooltip: React.FC<TooltipProps> = ({ items, position, visible }) => {
  // todo use mui variables and remove Tooltip.css
  const TooltipConiner = styled(Box)({
    background: '#0c1017',
    display: visible ? "block" : "none",
    left: position.x,
    transform: "translate(-50%, -100%)",
    padding: '10px',
    opacity: 1,
    top: position.y,

  });

  const Row = styled(Box)({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    fontSize: '0.8rem',
    justifyContent: 'flex-start',
    margin: '5px 0',
    minWidth: 'fit-content',
    whiteSpace: 'nowrap',
  });

  const Bullet = styled('div')<{ color?: string }>(({ color }) => ({
    background: color,
    borderRadius: '50%',
    height: '8px',
    marginRight: '10px',
    minWidth: '8px',
    width: '8px',
  }));

  return (
    <TooltipConiner className="tooltip">
      {items.map((item, index) => (
        <div key={index} style={{ color: item.color }}>
          {item.imageUrl ? (
            <img
              src={item.imageUrl}
              alt="Tooltip"
              style={{ maxWidth: "100px", maxHeight: "100px" }}
            />
          ) : (
            <Row>
              <Bullet color={item.color} />
              {item.text}
            </Row>
          )}
        </div>
      ))}
    </TooltipConiner>
  );
};

export default Tooltip;
